import { css } from 'styled-components';

const FontStyles = css`
  :root {
    --font-sans: 'Calibre', 'San Francisco', 'SF Pro Text', -apple-system, system-ui, sans-serif;
    --font-mono: 'SF Mono', 'Fira Code', 'Fira Mono', 'Roboto Mono', monospace;

    --fz-xxs: 12px;
    --fz-xs: 13px;
    --fz-sm: 14px;
    --fz-md: 16px;
    --fz-lg: 18px;
    --fz-xl: 20px;
    --fz-xxl: 22px;
    --fz-heading: 32px;

    &:lang(ko) {
      --underline-offset: 0.1em;
      --fz-xxs: 12px;
      --fz-xs: 13px;
      --fz-sm: 14px;
      --fz-md: 15px;
      --fz-lg: 16px;
      --fz-xl: 17px;
      --fz-xxl: 20px;
      --fz-heading: 28px;
      --font-sans: 'Helvetica Neue', 'Helvetica', 'Apple SD Gothic Neo', 'NanumBarunGothic',
        'Malgun Gothic', dotum, 'Lucida Grande', sans-serif;
    }
  }
`;

export default FontStyles;
